import script from "./ContentMediaTypeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentMediaTypeSelector.vue?vue&type=script&setup=true&lang=js"

import "./ContentMediaTypeSelector.vue?vue&type=style&index=0&id=c831a84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c831a84c"]])

export default __exports__